import React, {JSX} from 'react';

import {CopyButton} from 'src/components/copy-button/copy-button';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group, Item} from '@pb/kit-component-group';
import {Sizes} from '@pb/kit-component-icon';

import {pageHeadline, pageHeadlineTitle} from './page-headline.module.styl';

type Props = {
    caption: string,
    captionToCopy?: string,
    children?: JSX.Element,
};

export const PageHeadline = ({caption, captionToCopy, children}: Props) => {
    return (
        <Item className={pageHeadline} style={{width: '100%'}}>
            <Group justify="space-between" alignItems="center">
                <Group justify="start" className={pageHeadlineTitle} style={{width: '50%'}}>
                    <EllipsisTextHint>{caption}</EllipsisTextHint>
                    {captionToCopy ? <CopyButton textToCopy={captionToCopy} size={Sizes.Size_19}/> : null}
                </Group>
                <Item>{children || null}</Item>
            </Group>
        </Item>
    );
};
